import React from 'react'
import styled from 'styled-components'

import '../styles/spectre.css';

const InputDropdownTemplate = styled.div`

.form-group.es-i-template {

  font-family: "Open Sans";


  label.form-label {
    margin-bottom: 5px;
    font-weight: 700;
    color: #666;
    font-size: 14px;
    font-weight: 600;
    width: 70%;

    span {
      color: #26c1fb;
    }
  }
}

`;

const EchoShipInput = (props) => {
  return (
    <InputDropdownTemplate>
        <div className="form-group es-i-template"
        style={{
          width: "80%"
        }}
        >
        <label className="form-label" htmlFor="input-example-1">
          {props.labelTitle}
        </label>
        <select className="form-select select-lg">
          <option>Shipment</option>
          <option>Delivery (Latest-Oldest)</option>
          <option>Status (A-Z)</option>
          <option>Total Cost Status (A-Z)</option>
          <option>Total Cost Status (Z-A)</option>
        </select>
        </div>
    </InputDropdownTemplate>
  )
}

export default EchoShipInput;